import { render, staticRenderFns } from "./lrFormItem.vue?vue&type=template&id=503bd448&"
import script from "./lrFormItem.vue?vue&type=script&lang=js&"
export * from "./lrFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports